import React, { useState } from 'react'
import PropTypes from 'prop-types'
import RegionBranchMultipleSelect from 'component/branch/RegionBranchMultipleSelectNew'
import ThemeSelectField from 'component/priceBanner/selects/ThemeSelectField'
import ProductMultipleSelect from 'component/priceBanner/selects/ProductMultipleSelect'
import ListSelectField from 'component/priceBanner/selects/ListSelectField'
import 'container/priceBanner/styles.css';

const InlineFilterProduct = ({
  inlineFilterVisible,
  submit,
  translate,
  closeFilters,
  user
}) => {
  const initialState = {
    idBranches: [],
    theme: null,
    list: null,
    products: [],
  };

  const [formData, setFormData] = useState(initialState);
  const [setAllBranches] = useState([]);
  const hasAnyFilterApplied = () => {
    const hasProducts = formData.products && formData.products.length > 0;
    const hasList = formData.list && formData.list.value;
    const hasTheme = formData.theme && formData.theme.value;
    const hasBranches = formData.idBranches && formData.idBranches.length > 0;
    return hasProducts || hasList || hasTheme || hasBranches;
  };

  const submitValues = () => {
    const transformedData = {
      idBranches: formData.idBranchesCodes || [],
    };
    if (formData.theme && formData.theme.value && formData.theme.value !== "todos") {
      transformedData.themeCode = formData.theme.value;
    }
    if (formData.list && formData.list.value && formData.list.value !== "todos") {
      if (Array.isArray(formData.list.value)) {
        transformedData.listIds = formData.list.value;
      } else {
        transformedData.listId = formData.list.value;
      }
    }
    if (formData.products && formData.products.length > 0) {
      transformedData.productLms = formData.products.map(product => product.value);
    }
    submit(transformedData);
    closeFilters();
  };

  const handleFormChange = (field, selectedValue) => {
    if (field === 'idBranches') {
      const branchCodes = selectedValue.flatMap((item) => {
        if (item.idBranches) return item.idBranches;
        if (item.isBranch) return item.value;
        return [];
      });
      setFormData((prev) => ({
        ...prev,
        [field]: selectedValue,
        [`${field}Codes`]: branchCodes,
      }));
    } else if (field === 'theme') {
      setFormData((prev) => ({
        ...prev,
        theme: selectedValue || null,
      }));
    } else if (field === 'list') {
      setFormData((prev) => ({
        ...prev,
        list: selectedValue || null,
      }));
    } else if (field === 'products') {
      setFormData((prev) => ({
        ...prev,
        products: selectedValue || [],
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [field]: selectedValue,
      }));
    }
  };

  return (
    <>
      {inlineFilterVisible && (
        <div className='inline-filter-product'>
          <div className='filter-inventory filter-vertical'>
            <div className='flex-container'>
              <div className='inventory-title margin-bottom-small'>
                <h2>
                  {translate('mobile.filter')}
                </h2>
              </div>
              <div className='big margin-bottom-small'>
                <ProductMultipleSelect
                  label={translate('priceBannerNewFragment.lm')}
                  placeholder={translate('price.banner.select.lm')}
                  value={formData.products}
                  onChange={(value) => handleFormChange('products', value)}
                  required={true}
                  fill={true}
                  showHelperArea={false}
                />
              </div>
              <div className='big margin-bottom-small'>
                <ListSelectField
                  label={translate('price.banner.listname')}
                  placeholder={translate("price.banner.select.list")}
                  user={user}
                  translate={translate}
                  onChange={(e) => handleFormChange('list', e)}
                  value={formData.list}
                  required={true}
                  fill={true}
                  showAllOption={true}
                  groupByName={true}
                />
              </div>
              <div className='big margin-bottom-small'>
                <ThemeSelectField
                  label={translate('price.banner.theme')}
                  placeholder={translate('price.banner.select.theme')}
                  user={user}
                  translate={translate}
                  onChange={(e) => handleFormChange('theme', e)}
                  value={formData.theme}
                  required={true}
                  fill={true}
                  showAllOption={true}
                />
              </div>
              <div className='big margin-bottom-small'>
                <RegionBranchMultipleSelect
                  required
                  name='idBranches'
                  label={translate('irc.store')}
                  placeholder={translate("field.selectMultiStores")}
                  user={user}
                  translate={translate}
                  onChange={(e) => handleFormChange('idBranches', e.target.value)}
                  value={formData.idBranches}
                  getAllBranchs={setAllBranches}
                />
              </div>
              <div className='small div-button'>
                <button
                  role='button'
                  type='button'
                  className='btn btn-primary full-w'
                  disabled={!hasAnyFilterApplied()}
                  onClick={submitValues}
                >
                  {translate('commonReport.filter')}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

InlineFilterProduct.propTypes = {
  inlineFilterVisible: PropTypes.bool.isRequired,
  submit: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  closeFilters: PropTypes.func.isRequired,
  user: PropTypes.object
}

export default InlineFilterProduct
export { InlineFilterProduct }
